/** Central paths for rebranded imagery under public/images/brand */
export const brandImages = {
  wordmarkOnLight: "/images/brand/kynzo-wordmark-black-transparent.png",
  wordmarkOnDark: "/images/brand/kynzo-wordmark-white-transparent.png",
  wordmarkOpaque: "/images/brand/kynzo-wordmark.png",
  icon: "/images/brand/kynzo-icon-black-transparent.png",
  iconOnDark: "/images/brand/kynzo-icon-white-transparent.png",
  faviconSrc: "/images/brand/kynzo-favicon-transparent.png",
};
